import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, type PropType, onMounted, watch, computed } from "vue";

import { TrashIcon } from "@heroicons/vue/24/outline";

import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import ErrorModal from "@/components/modals/ErrorModal.vue";
import PageLoader from "@/components/loaders/PageLoader.vue"

import InterventionTypeService from "@/classes/Settings/InterventionTypeService.ts"

import { FormInterface } from "@/interfaces/pages/Settings/InterventionFormInterface.ts";


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteButton',
  props: { 
    form: {
        type: Object as PropType<FormInterface>,
        required: true,
    },
},
  emits: ['delete:success'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;


const loading = ref<boolean>(false);
const showConfirmation = ref<boolean>(false);

const showSuccess = ref<boolean>(false);
const successMessage = ref<string>('');

const showError = ref<boolean>(false);
const errorMessage = ref<string>('');


const deleteForm = ():void => {
    loading.value = true;
    showConfirmation.value = false;
    
    InterventionTypeService
        .delete(props.form.id)
        .then(({data}) => {
            showSuccess.value = true
            successMessage.value = data.message
            
            emit('delete:success', data.data)
        })
        .catch((error: any) => {
            console.log(error);
            showError.value = true;
            errorMessage.value = error.response.data.message
        })
        .finally(() => loading.value = false)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TrashIcon), {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showConfirmation.value = true)),
      class: "w-5 h-5 transition cursor-pointer hover:text-red-700",
      "aria-hidden": "true"
    }),
    _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"]),
    _createVNode(ConfirmationModal, {
      typeTwo: true,
      show: showConfirmation.value,
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (showConfirmation.value = false)),
      onConfirm: _cache[2] || (_cache[2] = ($event: any) => (deleteForm())),
      "cancel-text": "Cancel",
      "action-text": "Confirm",
      title: `Removal Warning of ${__props.form.label}`,
      content: "This field is connected to a sub-form. Removing this field will remove the child forms as well.?"
    }, null, 8, ["show", "title"]),
    _createVNode(SuccessModal, {
      show: showSuccess.value,
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showSuccess.value = false)),
      "action-text": "Close",
      title: "Success!",
      content: successMessage.value
    }, null, 8, ["show", "content"]),
    _createVNode(ErrorModal, {
      show: showError.value,
      onConfirm: _cache[4] || (_cache[4] = ($event: any) => (showError.value = false)),
      "action-text": "Close",
      title: "Error!",
      content: errorMessage.value
    }, null, 8, ["show", "content"])
  ], 64))
}
}

})